module.exports = __webpack_public_path__ + "static/media/2.5d28f94a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/2.jpg
// module id = 55
// module chunks = 0